import OvertimeReportComponent from "features/Report/components/SalaryGroup/OvertimeReport";
import useOvertimeReport from "features/Report/hooks/salaryGroup/useOvertimeReport";

const OvertimeReportPage = () => {
    const useOvertimeReportProps = useOvertimeReport();
    return (
        <OvertimeReportComponent {...useOvertimeReportProps} />
    )
}

export default OvertimeReportPage;